module.exports = __webpack_public_path__ + "static/media/mcp_logo.2a1eed5b.png";